import React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from 'react-router-dom';

export default function BreadCrumbMUI({ level2, level3 }) {
  const navigate = useNavigate();

  return (
    <div role="presentation">
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={<span style={{ color: 'white' }}> / </span>}
      >
        <Link
          underline="hover"
          color="gray"
          onClick={() => navigate('/sustainability')}
          style={{ cursor: 'pointer' }}
        >
          Sustainability
        </Link>
        <Link
          underline="hover"
          color="white"
          onClick={() => navigate(`/sustainability/${level2}`)}
          style={{ cursor: 'pointer' }}
        >
          {level2}
        </Link>
      </Breadcrumbs>
    </div>
  );
}
